import { palette } from '../../../styles/material-ui/palette'

/** @type {Styles} */
export const styles = {
  selectRoot: {
    width: '100%',
    position: 'relative',
    '& .MuiPaper-root > ul': {
      paddingBottom: 0,
      padding: 0,
      width: '100%',
    },
    '& ul:first-of-type': {
      '& .MuiFormControl-root': {
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
      '& input': {
        color: 'gray.56',
        paddingTop: 1.25,
        paddingBottom: 1.5,
      },
      '& fieldset': {
        border: 'none',
      },
    },
    '& ul:last-child': {
      '& .MuiBox-root': {
        '& button:first-of-type': {
          '& svg': {
            color: 'primary.main',
          },
        },
        '& button:last-child': {
          color: 'gray.56',
        },
      },
    },
  },
  formControl: {
    width: '100%',
    borderColor: 'gray.16',
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'gray.56',
      },
    },
  },
  select: () => ({
    color: 'gray.80',
    width: '100%',
    borderRadius: 1,
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 400,
    '& .MuiSelect-select': {
      whiteSpace: 'pre-wrap',
      overflow: 'auto',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'gray.16',
    },
    '&.Mui-focused': {
      color: 'primary.main',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main',
      },
    },

    '& .MuiSvgIcon-root': {
      color: 'gray.56',
    },
    '& .Mui-checked': {
      '& .MuiSvgIcon-root': {
        color: 'primary.main',
      },
    },
    '.MuiPaper-root': {
      backgroundColor: 'gray.0',
    },

    '& .MuiPopover-root': {
      height: { xs: 250, sm: 350 },
      width: { xs: '80%', sm: '20%' },
    },
  }),
  label: {
    '&.Mui-focused': {
      color: 'primary.main',
    },
    color: 'gray.56',
  },
  checkbox: {
    margin: 0,
    marginRight: 2,
    padding: 0,
  },
  menuItemAvatar: {
    marginRight: 1.5,
  },
  optionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  hasDivider: {
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: 'gray.8',
  },
  menuItems: {
    paddingTop: 1.5,
    paddingBottom: 1.5,
    '&:hover': {
      backgroundColor: 'primary.lightest',
    },
    '& .MuiFormGroup-root': {
      width: '100%',
      '& .MuiFormControlLabel-root': {
        margin: 0,
      },
      '& .MuiCheckbox-root': {
        padding: 0,
        marginRight: 2,
      },
    },
    '&.Mui-selected': {
      backgroundColor: 'primary.lightest',
      '&:hover': {
        backgroundColor: 'primary.lightest',
      },
      '& .MuiListItemText-primary': {
        fontWeight: 600,
        color: 'primary.main',
      },
      '& .MuiListItemIcon-root': {
        color: 'primary.main',
      },
      '& .MuiSvgIcon-root': {
        color: 'primary.main',
      },
    },
  },
  menuItemText: {
    color: 'gray.80',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 1.5,
    '& span': {
      color: 'gray.80',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 1.5,
    },
  },
  menuItemCheckbox: {
    padding: 0,
    marginRight: 2.5,
  },
  checkboxFormGroup: {
    '&.MuiFormGroup-root': {
      width: 'auto!important',
    },
  },
  menuItemIcon: {
    minWidth: 'auto !important',
    marginRight: 1.5,
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20,
      fontSize: 20,
    },
  },
  icon: {
    width: 20,
    height: 20,
    fontSize: 20,
  },
  selectedIconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  selectedItemStack: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
  },
  chipRoot: {
    backgroundColor: 'primary.lightest',
    color: 'primary.main',
    fontWeight: 600,
    paddingY: 0.75,
    paddingX: 0,
    borderRadius: 1,
    fontSize: 14,
    '& .MuiChip-deleteIcon': {
      color: 'primary.main',
      '&:hover': {
        color: 'primary.dark',
      },
    },
  },
  checkboxLabel: {
    color: 'gray.80',
  },
  dividerStyles: {
    marginTop: 3,
    marginBottom: 2,
  },
  customHeaderLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
  },
  customHeader: {
    padding: 2.5,
    paddingBottom: 1,
    color: 'gray.80',
    typography: 'header4',
  },
  customLabel: {
    typography: 'body2',
    color: 'gray.80',
    marginTop: 0.5,
  },
  bottomSheetPaperRoot: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
  },
  bottomSheetBtnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'gray.3',
  },
  searchBarPaperRoot: {
    position: 'sticky',
    zIndex: 1000,
    top: 0,
    left: 0,
    right: 0,
  },
  searchBarPaper: {
    position: 'sticky',
    zIndex: 1000,
    top: 0,
    left: 0,
    right: 0,
    boxShadow: 'none',
  },
  searchBar: {
    zIndex: 1000,
    width: '100%',
    backgroundColor: 'gray.3',
  },
  searchIcon: { marginRight: 2 },
  clearSearchIcon: { fontSize: 20, cursor: 'pointer' },
  customlistContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  checklistContainer: { display: 'flex', alignItems: 'center' },
  noResultFound: {
    display: 'flex',
    justifyContent: 'center',
    padding: 1,
    height: 100,
  },
  scroller: {
    overflow: 'overlay',
    height: 'fit-content',
    maxHeight: '40vh',
    scrollbarColor: 'gray.3',
    '::-webkit-scrollbar': {
      width: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      background: palette.custom.table.main,
    },
  },
  topLabelContainer: { mb: 1, display: 'flex', alignItems: 'center' },
  draggableMenuItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dragHandle: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
    marginRight: 1,
    flexShrink: 0,
  },
  dragHandleIcon: {
    width: 16,
    height: 16,
    color: 'gray.40',
  },
}

export const menuItemStyles = () => {
  return { paddingLeft: 2, paddingTop: 1.5, paddingBottom: 1.5 }
}
